{
  "familyId": "MET-HOEK-METEN",
  "questions": [
    {
      "id": "MET-HOEK-METEN-001",
      "familyId": "MET-HOEK-METEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_meten",
      "questionType": "multiple_choice",
      "question": "Je meet een hoek met een geodriehoek. De ene lijn wijst naar 20° en de andere naar 85°. Hoe groot is de hoek?",
      "context": null,
      "options": ["65°", "85°", "105°", "20°"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 65,
            "showValue": true,
            "angleType": "scherp",
            "label": "De hoek is 85° − 20° = 65°"
          }
        }
      ],
      "conceptId": "hoek_meten_verschil",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.hoek-type-verward", "label": "Alleen de grootste waarde gelezen (85°) i.p.v. het verschil", "optionIndex": 1 },
          { "id": "met.hoek-draai-verward", "label": "Waarden opgeteld (20° + 85° = 105°) i.p.v. afgetrokken", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Als je een hoek meet en de lijnen niet bij 0° beginnen, bereken je het verschil. De ene lijn staat op 20° en de andere op 85°. De hoek is: 85° − 20° = 65°. Onthoud: de hoek is het verschil tussen de twee richtingen. Check: 65° is scherp (< 90°) ✓.",
        "solutionSteps": [
          "Lees de twee waarden af: 20° en 85°",
          "Bereken het verschil: 85° − 20° = 65°",
          "Check: 65° is scherp (< 90°) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De hoek is het verschil: 85° − 20° = 65°.",
          "1": "Je dacht waarschijnlijk dat de hoek gelijk is aan de grootste waarde (85°). Maar je moet het verschil berekenen: 85° − 20° = 65°. Onthoud: hoek = eindwaarde − beginwaarde.",
          "2": "Je dacht waarschijnlijk dat je de twee waarden moet optellen: 20° + 85° = 105°. Maar je berekent het verschil, niet de som. Onthoud: hoek = groot getal − klein getal.",
          "3": "Je dacht waarschijnlijk dat de hoek gelijk is aan de kleinste waarde (20°). Maar 20° is slechts het startpunt. De hoek is het verschil: 85° − 20° = 65°."
        }
      }
    },
    {
      "id": "MET-HOEK-METEN-002",
      "familyId": "MET-HOEK-METEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_meten",
      "questionType": "multiple_choice",
      "question": "Je meet een hoek met een geodriehoek. De ene lijn wijst naar 0° en de andere naar 65°. Hoe groot is de hoek?",
      "context": null,
      "options": ["25°", "115°", "65°", "130°"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 65,
            "showValue": true,
            "angleType": "scherp",
            "label": "Nullijn op 0° → aflezen: 65°"
          }
        }
      ],
      "conceptId": "hoek_aflezen_geodriehoek",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.hoek-type-verward", "label": "Buitenste schaal gelezen: 180° − 65° = 115°", "optionIndex": 1 },
          { "id": "met.hoek-draai-verward", "label": "90° − 65° = 25° berekend i.p.v. direct aflezen", "optionIndex": 0 }
        ]
      },
      "feedback": {
        "explanationText": "De ene lijn staat op 0° en de andere op 65°. De hoek is het verschil: 65° − 0° = 65°. Onthoud: als je bij 0° begint, is het afgelezen getal direct de hoek.",
        "solutionSteps": [
          "Eén lijn op 0° (de nullijn)",
          "Andere lijn op 65°",
          "Check: hoek = 65° − 0° = 65° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 90° − 65° moet rekenen. Maar je trekt af van de nullijn (0°), niet van 90°. Onthoud: hoek = eindwaarde − beginwaarde.",
          "1": "Je dacht waarschijnlijk dat je de buitenste schaal moet lezen. De geodriehoek heeft twee schalen. Als je bij 0° begint, lees je de binnenste schaal: 65°. Onthoud: begin altijd bij 0°.",
          "2": "Goed! De hoek is 65° − 0° = 65°.",
          "3": "Je dacht waarschijnlijk dat je moet verdubbelen. Maar de hoek is gewoon het verschil: 65° − 0° = 65°."
        }
      }
    },
    {
      "id": "MET-HOEK-METEN-003",
      "familyId": "MET-HOEK-METEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_meten",
      "questionType": "multiple_choice",
      "question": "Je meet een hoek en leest 135° af op de geodriehoek. Je twijfelt: is het 135° of 45°? Hoe weet je welke schaal je moet gebruiken?",
      "context": null,
      "options": [
        "Kies altijd het kleinste getal",
        "Kijk of de hoek groter of kleiner dan 90° lijkt",
        "Kies altijd het grootste getal",
        "Het maakt niet uit, beide zijn goed"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 135,
            "showValue": true,
            "angleType": "stomp",
            "compareAngle": 45,
            "label": "45° en 135° staan op dezelfde plek"
          }
        }
      ],
      "conceptId": "hoek_meten_twee_schalen",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.hoek-type-verward", "label": "Denkt dat je altijd het kleinste getal kiest", "optionIndex": 0 },
          { "id": "met.hoek-type-verward", "label": "Denkt dat je altijd het grootste getal kiest", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "De geodriehoek heeft twee schalen die samen 180° maken: 45° en 135° staan op dezelfde plek. Om de juiste te kiezen, schat je eerst: lijkt de hoek groter of kleiner dan 90°? Als de hoek er stomp uitziet (wijder dan recht), kies je 135°. Als hij scherp lijkt, kies je 45°. Onthoud: eerst schatten, dan aflezen.",
        "solutionSteps": [
          "De geodriehoek toont twee getallen: 45° en 135°",
          "Schat: is de hoek scherp (< 90°) of stomp (> 90°)?",
          "Kies de schaal die past bij je schatting",
          "Check: 45° + 135° = 180° (aanvullende hoeken) ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je altijd het kleinste getal kiest. Maar stompe hoeken zijn groter dan 90°, dus dan moet je juist het grotere getal kiezen. Onthoud: eerst schatten, dan kiezen.",
          "1": "Goed! Schat eerst of de hoek scherp of stomp is, en kies dan de juiste schaal.",
          "2": "Je dacht waarschijnlijk dat je altijd het grootste getal kiest. Maar scherpe hoeken zijn kleiner dan 90°, dus dan moet je het kleinere getal kiezen. Onthoud: eerst schatten, dan kiezen.",
          "3": "Het maakt wél uit! 45° en 135° zijn heel verschillende hoeken. Als je de verkeerde schaal leest, meet je de aanvullende hoek in plaats van de echte hoek."
        }
      }
    },
    {
      "id": "MET-HOEK-METEN-004",
      "familyId": "MET-HOEK-METEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_meten",
      "questionType": "ordering",
      "question": "Zet de stappen voor het meten van een hoek met een geodriehoek in de juiste volgorde.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Midden op het hoekpunt",
          "Nullijn langs één been",
          "Aflezen waar het andere been de boog raakt",
          "Controleren: scherp of stomp?"
        ],
        "correctOrder": [0, 1, 2, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappen bij hoek meten",
            "content": "1. Midden op het hoekpunt\n2. Nullijn op één been\n3. Aflezen op de boog\n4. Controleren of het antwoord logisch is",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_meten_stappen",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "De juiste volgorde is: 1) Leg het midden op het hoekpunt. 2) Leg de nullijn langs één been. 3) Lees af waar het andere been de boog raakt. 4) Controleer of het antwoord past bij wat je ziet. Onthoud: midden → nullijn → aflezen → controleren.",
        "solutionSteps": [
          "Stap 1: Midden op het hoekpunt leggen",
          "Stap 2: Nullijn langs één been leggen",
          "Stap 3: Aflezen waar het andere been de boog raakt",
          "Check: controleren of het antwoord logisch is ✓"
        ]
      }
    },
    {
      "id": "MET-HOEK-METEN-005",
      "familyId": "MET-HOEK-METEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_meten",
      "questionType": "fill_in",
      "question": "Je meet een hoek. De ene lijn wijst naar 10° en de andere naar 80° op de geodriehoek. Hoe groot is de hoek?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["70", "70°"],
        "caseSensitive": false,
        "inputType": "number",
        "unit": "°",
        "placeholder": "Aantal"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 70,
            "showValue": true,
            "angleType": "scherp",
            "label": "De hoek is 80° − 10° = 70°"
          }
        }
      ],
      "conceptId": "hoek_meten_verschil_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "De hoek is het verschil tussen de twee afgelezen waarden op de geodriehoek: 80° − 10° = 70°. Onthoud: de hoek is altijd het verschil, ook als je niet bij 0° begint.",
        "solutionSteps": [
          "Lees af: 10° en 80°",
          "Bereken het verschil: 80° − 10° = 70°",
          "Check: 70° is scherp (< 90°) ✓"
        ]
      }
    }
  ]
}